import Container from "@/components/Container";
import Typography from "@/components/Typography";
import PodcastTile from "@/components/FeedTiles/PodcastTile/";
import useRequest from "@/helpers/useRequest";
import { apiPath } from "@/helpers/apiPath";
import { RecommendedTypes } from "@/helpers/pageHelpers/Common/interface";
import { PodcastTileInterface } from "@/helpers/pageHelpers/Podcast/interface";
import { EpisodeInterface } from "@/helpers/pageHelpers/Episode/interface";
import { ContextualMenuEnum } from "@/components/ContextualMenu/ContextualMenu.interface";
import { useScroll } from "@/helpers/useScroll";

import styles from "./LatestSection.module.scss";

const LatestSection: React.FC<{ episodes: EpisodeInterface[] }> = ({
  episodes,
}) => {
  const { scrollWrapperRef } = useScroll();
  const { data } = useRequest(apiPath.EPISODE_LIST({ perPage: 7 }), {
    initialData: episodes,
  });

  if (!data) {
    return <></>;
  }

  return (
    <section className={styles.latest}>
      <Container>
        <Typography variant="h4" component="h4" className={styles.title}>
          Najnowsze epizody
        </Typography>
      </Container>
      <div className={styles.episodes} ref={scrollWrapperRef}>
        <div className={styles.box} />
        {data?.items.map(({ object, type }, index) => {
          return (
            type === RecommendedTypes.Episode && (
              <PodcastTile
                key={index}
                {...(object as PodcastTileInterface)}
                size="small"
                contextualMenuVariant={ContextualMenuEnum.Latest}
              />
            )
          );
        })}
      </div>
    </section>
  );
};

export default LatestSection;
